import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
// import { contentSpacingStyles } from "@tSurya/theme/mixins";
// import breakpointValuesMediaQueries from "@tSurya/utilities/breakpointValuesMediaQueries";
import { css } from "styled-components";

export default {
    fontFamilyImportUrl: TYPOGRAPHY.fontFamilyImportUrl,
    body: {
        fontFamily: TYPOGRAPHY.body.fontFamily,
        lineHeight: TYPOGRAPHY.body.lineHeight,
        size: TYPOGRAPHY.body.size,
        weight: TYPOGRAPHY.body.weight,
        color: getColor("text.main"),
        letterSpacingBody: TYPOGRAPHY.body.letterSpacing,
    },
    p: {
        fontFamily: TYPOGRAPHY.p.fontFamily,
        size: TYPOGRAPHY.p.size,
        weight: TYPOGRAPHY.p.weight,
        lineHeight: TYPOGRAPHY.p.lineHeight,
        color: getColor("text.main"),
        letterSpacing: TYPOGRAPHY.p.letterSpacing,
    },
    h1: {
        size: TYPOGRAPHY.h1.size,
        weight: TYPOGRAPHY.h1.weight,
        lineHeight: TYPOGRAPHY.h1.lineHeight,
        fontFamily: TYPOGRAPHY.h1.fontFamily,
        color: getColor("text.main"),
        ...((TYPOGRAPHY.h1 as any).italic && { italic: (TYPOGRAPHY.h1 as any).italic }),
    },
    h2: {
        size: TYPOGRAPHY.h2.size,
        weight: TYPOGRAPHY.h2.weight,
        lineHeight: TYPOGRAPHY.h2.lineHeight,
        fontFamily: TYPOGRAPHY.h2.fontFamily,
        color: getColor("text.main"),
        ...((TYPOGRAPHY.h2 as any).italic && { italic: (TYPOGRAPHY.h2 as any).italic }),
    },
    h3: {
        size: TYPOGRAPHY.h3.size,
        weight: TYPOGRAPHY.h3.weight,
        lineHeight: TYPOGRAPHY.h3.lineHeight,
        fontFamily: TYPOGRAPHY.h3.fontFamily,
        color: getColor("text.main"),
        ...((TYPOGRAPHY.h3 as any).italic && { italic: (TYPOGRAPHY.h3 as any).italic }),
    },
    h4: {
        size: TYPOGRAPHY.h4.size,
        weight: TYPOGRAPHY.h4.weight,
        lineHeight: TYPOGRAPHY.h4.lineHeight,
        fontFamily: TYPOGRAPHY.h4.fontFamily,
        color: getColor("text.main"),
        ...((TYPOGRAPHY.h4 as any).italic && { italic: (TYPOGRAPHY.h4 as any).italic }),
    },
    h5: {
        size: TYPOGRAPHY.h5.size,
        weight: TYPOGRAPHY.h5.weight,
        lineHeight: TYPOGRAPHY.h5.lineHeight,
        fontFamily: TYPOGRAPHY.h5.fontFamily,
        color: getColor("text.main"),
        ...((TYPOGRAPHY.h5 as any).italic && { italic: (TYPOGRAPHY.h5 as any).italic }),
    },
    h6: {
        size: TYPOGRAPHY.h6.size,
        weight: TYPOGRAPHY.h6.weight,
        lineHeight: TYPOGRAPHY.h6.lineHeight,
        fontFamily: TYPOGRAPHY.h6.fontFamily,
        color: getColor("text.main"),
        ...((TYPOGRAPHY.h6 as any).italic && { italic: (TYPOGRAPHY.h6 as any).italic }),
    },
    headerPrimary: {
        transform: TYPOGRAPHY.headerPrimary.transform,
        size: TYPOGRAPHY.headerPrimary.size,
        weight: TYPOGRAPHY.headerPrimary.weight,
        lineHeight: TYPOGRAPHY.headerPrimary.lineHeight,
        fontFamily: TYPOGRAPHY.headerPrimary.fontFamily,
        color: TYPOGRAPHY.headerPrimary.color ? getColor(TYPOGRAPHY.headerPrimary.color) : getColor("text.main"),
    },
    headerSecondary: {
        size: TYPOGRAPHY.headerSecondary.size,
        transform: TYPOGRAPHY.headerSecondary.transform,
        fontFamily: TYPOGRAPHY.headerSecondary.fontFamily,
        lineHeight: TYPOGRAPHY.headerSecondary.lineHeight,
        weight: TYPOGRAPHY.headerSecondary.weight,
        color: getColor("text.main"),
    },
    headerTertiary: {
        transform: TYPOGRAPHY.headerTertiary.transform,
        size: TYPOGRAPHY.headerTertiary.size,
        lineHeight: TYPOGRAPHY.headerTertiary.lineHeight,
        weight: TYPOGRAPHY.headerTertiary.weight,
        fontFamily: TYPOGRAPHY.headerTertiary.fontFamily,
        color: TYPOGRAPHY.headerTertiary.color ? getColor(TYPOGRAPHY.headerTertiary.color) : getColor("text.main"),
    },
    legend: {
        size: TYPOGRAPHY.legend.size,
        color: TYPOGRAPHY.legend.color ? getColor(TYPOGRAPHY.legend.color) : getColor("text.accent"),
        transform: TYPOGRAPHY.legend.transform,
        weight: TYPOGRAPHY.legend.weight,
        fontFamily: TYPOGRAPHY.fontFamily.base, // fallback to base font family since legend doesn't have its own
    },
    link: {
        size: TYPOGRAPHY.link.size,
        weight: TYPOGRAPHY.link.weight,
        lineHeight: TYPOGRAPHY.link.lineHeight,
        color: getColor("text.link"),
    },
};
